export class Common {
    static escapeRegExp (str : string) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&")
    }
}



// WEBPACK FOOTER //
// ./components/common/Common.ts